<template>
  <!--两客一危一重客户参数-->
  <div>
    <Row>
      <Select v-model="selectYeHu" style="width:300px; margin-right: 10px;">
        <Option v-for="item in yeHuList" :value="item.id" :key="item.name">{{ item.name }}</Option>
      </Select>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onExportClick">导出</Button>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onPackClick">打包台账</Button>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onDownloadZipClick">下载打包台账</Button>
    </Row>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import { mapActions } from 'vuex'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { numberFormat } from '@/libs/numberutil'

  export default {
    name: "gddlysjgvehiclequalifications",
    components:{

    },
    data(){
      return{
        yeHuList:[],
        selectYeHu:null,
        selectDatetime:new Date()
      }
    },
    methods:{
      onPackClick(){
        if (!this.selectDatetime) {
          this.$Message.error('未选择日期')
          return
        }
        let sDatetime = this.selectDatetime.Format('yyyy-MM-dd 00:00:00')
        store.dispatch('GdDlysjgVehicleQualificationServ_MakePackage', {
          params: {selectDatetime:sDatetime},
          urlparams: null
        }).then(() => {
          this.$Message.success('开始打包');
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onDownloadZipClick(){
        if (!this.selectDatetime) {
          this.$Message.error('未选择日期')
          return
        }
        let sDatetime = this.selectDatetime.Format('yyyy-MM-dd 00:00:00')
        let url = '/api/gdviss/gddlysjgvehiclequalification/downloadpackage?selectDatetime=' + sDatetime
        window.location.href = url
      },
      onExportClick(){
        console.log(this.selectYeHu)
        let syh = null;bao
        for(let i = 0;i < this.yeHuList.length; i++){
          if(this.yeHuList[i].id == this.selectYeHu){
            syh = this.yeHuList[i];
            break;
          }
        }
        console.log(syh)
        let url = '/api/gdviss/gddlysjgvehiclequalification/exportexcel?yeHuName=' + syh.name
        window.location.href = url
      }
    },
    mounted () {
      this.$nextTick(() => {
        store.dispatch('GdDlysjgVehicleQualificationServ_GetYeHuList', {
          params: null,
          urlparams: null
        }).then(() => {
          this.yeHuList = store.getters.get_GdDlysjgVehicleQualification_GetYeHuListResult
        }).catch(err => {
          this.$Message.error(err)
        })
      })
    },
    destroyed() {

    }
  }
</script>

<style scoped>

</style>
